import * as React from 'react';
import classnames from 'classnames';
import { Price } from '@grandvisionhq/common';

const Discount = ({ absoluteValue , relativeValue , currency , labels , className  })=>{
    const hasAbsoluteValue = absoluteValue > 0;
    const hasRelativeValue = (relativeValue !== null && relativeValue !== void 0 ? relativeValue : 0) > 0;
    if (!hasAbsoluteValue && !hasRelativeValue) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('line-item-discount__section', className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "line-item-discount__section-text"
    }, labels.discount, "\xa0"), hasAbsoluteValue ? /*#__PURE__*/ React.createElement(Price, {
        value: absoluteValue,
        currency: currency,
        className: "line-item-discount__section-price",
        type: "discount"
    }) : /*#__PURE__*/ React.createElement("span", {
        className: "line-item-discount__section-value"
    }, relativeValue, "%"));
};

export { Discount };
//# sourceMappingURL=Discount.js.map
